export const SEAT_ASSET_ID = '';
export const SIDE_KEYWORD = ['left', 'top', 'right', 'bottom'];
export const VERTEX_KEYWORD = [
  'topLeft',
  'topRight',
  'bottomRight',
  'bottomLeft',
];
export const SIDE_MAP = {
  left: 'right',
  right: 'left',
  top: 'bottom',
  bottom: 'top',
};
export const SIDE_VERTICES_MAP = {
  left: ['bottomLeft', 'topLeft'],
  top: ['topLeft', 'topRight'],
  right: ['topRight', 'bottomRight'],
  bottom: ['bottomRight', 'bottomLeft'],
};
export const SIDE_DIMENSION_MAP = {
  left: 'height',
  right: 'height',
  top: 'width',
  bottom: 'width',
};
export const ALIGNMENT_MAP = {
  top: 'bottom',
  bottom: 'top',
};
// export const SEAT_WIDTH = 0.8865;
// export const SEAT_HEIGHT = 0.734;
// export const SIDE_WIDTH = 0.8865;

export const SEAT_WIDTH = 0.889;
export const SEAT_HEIGHT = 0.7366;
export const SIDE_WIDTH = 0.889;
export const SIDE_HEIGHT = 0.1525;
export const FLOAT_POINT_ADJUST = 0.01;
export const PLUS_SIGN_DISTANCE = 0.175;
export const ATTACH_THRESHOLD = 0.3;
// export const DRAG_UNIT_DISTANCE = 1;
export const DRAG_UNIT_DISTANCE = 0.01;

export const SELECTION_COLORS = {
  VALID: '#56585A',
  INVALID: '#6C4E4E',
};

// Sides in array placed clockwisely
export const ALL_SEAT_SIDES = ['bottom', 'left', 'top', 'right'];

export const OPPOSITE_SEAT_SIDES = {
  left: 'right',
  right: 'left',
  top: 'bottom',
  bottom: 'top',
};

export const NEXT_SEAT_SIDES = {
  bottom: 'left',
  top: 'right',
  left: 'top',
  right: 'bottom',
};

export const PREVIOUS_SEAT_SIDES = {
  bottom: 'right',
  top: 'left',
  left: 'bottom',
  right: 'top',
};

export const PRODUCT_KEYS = {
  STANDARD: 'standard',
  ROLLARM: 'rollArm',
  ANGLED: 'angled',
  SWEPTARM: 'sweptArm',
  DEEP: 'deep',
  DEEP_ANGLED: 'deepAngled',
  DOUBLE_SIDED: 'doubleSided',
  WEDGE: 'wedge',
  ANYTABLE_2SHELVES: '2shelves',
  ANYTABLE_SHELFDRAWER: 'shelfDrawer',
};

export const SIDE_TYPE_KEYS = {
  Standard: PRODUCT_KEYS.STANDARD,
  Rollarm: PRODUCT_KEYS.ROLLARM,
  Angled: PRODUCT_KEYS.ANGLED,
  Sweptarm: PRODUCT_KEYS.SWEPTARM,
  Swept: PRODUCT_KEYS.SWEPTARM,
};

export const DEEP_SIDE_KEYS = {
  [PRODUCT_KEYS.STANDARD]: PRODUCT_KEYS.DEEP,
  [PRODUCT_KEYS.DOUBLE_SIDED]: PRODUCT_KEYS.DEEP,
  [PRODUCT_KEYS.ANGLED]: PRODUCT_KEYS.DEEP_ANGLED,
};

export const CONFIGURATOR_VERSION = 3;

export const PILLOW_CONFIG_MAP = {
  top: 'back',
  bottom: 'front',
  left: 'left',
  right: 'right',
};

export const SIDE_CONFIG_MAP = {
  back: 'top',
  front: 'bottom',
  left: 'left',
  right: 'right',
};


/**
 * Per-seat product variants. These are values of the `seatVariant` attribute on
 * the seat asset, so they are mutually exclusive by construction - a seat can be
 * exactly one of them.
 */
export const SEAT_VARIANTS = {
  STANDARD: 'standard',
  STORAGE: 'storage',
  RECLINING: 'reclining',
  ADJUSTABLE: 'adjustable',
};

/**
 * Variants that occupy the seat cavity and therefore cannot share a seat with a
 * StealthTech subwoofer.
 *
 * ADJUSTABLE is deliberately NOT in this list. It was, on the original brief that
 * an adjustable seat cannot host a subwoofer; that turned out to be wrong. An
 * adjustable seat takes a subwoofer like any standard seat, so it neither reduces
 * maxSubwoofers nor gets reset when a subwoofer lands on it. The only thing an
 * adjustable seat excludes is a reclining seat, and that exclusion is structural
 * (seatVariant holds one value) rather than anything StealthTech enforces.
 */
export const SUBWOOFER_CONFLICT_VARIANTS = [
  SEAT_VARIANTS.STORAGE,
  SEAT_VARIANTS.RECLINING,
];

export const ASSET_ID_3D = '4ccd4c4c-8a92-4168-90bf-79d88c028199';

